import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import CheckIcon from '@material-ui/icons/Check';

const pasos = Array(5).fill(0);

const Nav = (props) => {
    const check = (i) =>
        <>
            <IconButton key={i + 10} className="font-weight-bold mb-1" size="small" disabled={true} style={{ color: "white", backgroundColor: "#1BC5BD", width: 23, height: 23 }}>
                <CheckIcon />
            </IconButton>
            <b key={i + 20} className="d-none d-sm-block" style={{ color: "#1BC5BD" }}>{obtenerNombre(i)}</b>
        </>
    const actual = (i) =>
        <>
            <IconButton key={i + 30} className="font-weight-bold mb-1" size="small" disabled={true} style={{ color: "white", backgroundColor: "#1BC5BD", paddingLeft: 10, paddingRight: 10, fontSize: 11, width: 23, height: 23 }}>
                {i}
            </IconButton>
            <b key={i + 40} className="d-none d-sm-block" style={{ color: "#1BC5BD" }}>{obtenerNombre(i)}</b>
        </>
    const proximo = (i) =>
        <>
            <IconButton key={i + 50} className="font-weight-bold mb-1" size="small" disabled={true} style={{ color: "white", backgroundColor: "#8B8B8B", paddingLeft: 10, paddingRight: 10, fontSize: 11, width: 23, height: 23 }}>
                {i}
            </IconButton>
            <b key={i + 60} className="d-none d-sm-block">{obtenerNombre(i)}</b>
        </>
    const obtenerBoton = (i) => {
        const pasoActual = props.currentStep;
        if (pasoActual === 1 && i === 1) {
            return actual(i)
        } else if (pasoActual > 1 && i === 1) {
            return check(i)
        } else if (pasoActual > 1 && pasoActual <= 7 && i === 2) {
            return actual(i)
        } else if (pasoActual > 7 && i === 2) {
            return check(i)
        } else if (pasoActual > 7 && pasoActual <= 9 && i === 3) {
            return actual(i)
        } else if (pasoActual > 9 && i === 3) {
            return check(i)
        } else if (pasoActual > 9 && pasoActual <= 10 && i === 4) {
            return actual(i)
        } else if (pasoActual > 10 && i === 4) {
            return check(i)
        } else if (pasoActual === 11 && i === 5) {
            return actual(i)
        } else {
            return proximo(i)
        };
    };
    const obtenerNombre = (i) => {
        if (i === 1) {
            return "Aspirante";
        } else if (i === 2) {
            return "Responsable";
        } else if (i === 3) {
            return "Establecimiento";
        } else if (i === 4) {
            return "Extras";
        } else if (i === 5) {
            return "Resumen"
        };
    };
    return (
        <div className="d-flex justify-content-center">
            <div className="col-10 mt-5 mb-5 d-flex justify-content-between align-items-center">
                {pasos.map((paso, i) =>
                    <div key={i} className="d-flex flex-column align-items-center">{obtenerBoton(i + 1)}</div>
                )}
            </div>
        </div>
    )
};


export default Nav;